module.exports = __webpack_public_path__ + "static/media/8.65d50f2d.svg";